import DIApi from './_diApi';

class CashWithdrawTypeAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'CashWithdrawTypes';
}

export default new CashWithdrawTypeAPI();
